<template>
  <div class="Memor-box">
    <div class="Memor-left" ref="myDiv">
      <!-- <img src="../../../public/images/bjle.png"> -->
    </div>
    <div class="content">
      <div class="Memor-zhong">
        <div class="Memor-smb" v-if="infolist">
          <img :src="$uploadUrl + infolist.outside_style.cover" alt="">
          <div class="Memor-name">{{ infolist.name }}</div>
          <div class="Memor-cs">已祭拜：{{ infolist.pay_count }}次</div>
          <router-link :to="{ path: '/memorialwith', query: { id: infolist.id } }"
            class="Memor-goin">进入纪念堂</router-link>
        </div>

      </div>
      <div class="Memor-right">
        <div class="Memor-cent">
          <!-- <img src="../../../public/images/bjrig.png"> -->
          <div class="Memor-info">
            <div class="Memor-tab">
              <span :class="isave == item.id ? 'on' : ''" v-for="(item, index) in Tab" :key="index"
                @click="tab(item.id)">{{ item.name }}</span>
            </div>
            <div class="Memor-text" v-if="isave == 0">{{ infolist.intro }}</div>
            <div class="Memor-text" v-if="isave == 1 && infolist.life_tracks.length > 0">
              <div v-for="(item, index) in infolist.life_tracks" :key="index">
                <!-- <h4></h4> -->
                <div class="tracks_title">{{ item.title }}</div>
                <img class="tracks_img" v-if="item.picture[0]" :src="item.picture[0]" alt="" srcset="">
                <div class="tracks_detail " :class="item.showMore ? '' : 'ell'">
                  {{ item.content }}
                </div>
                <div class="tracks_btn" @click="showMore(item)">{{ item.showMore ? '收起' : '展开' }}>>
                </div>
              </div>
            </div>
            <div class="Memor-text" v-if="isave == 2">{{ infolist.houyi }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="" :style="{ height: Heig + 'px' }"></div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      Heig: '',
      Tab: [
        {
          name: '简介',
          id: 0
        },
        {
          name: '生平',
          id: 1
        },
        {
          name: '后裔',
          id: 2
        },
      ],
      isave: 0,
      setid: '',        //传过来的id
      infolist: '',     //数据
    };
  },
  created() {
    this.setid = this.$route.query.id;
    this.getData();
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.Heig = this.$refs.myDiv.clientHeight;
      });
    }, 200);

  },
  methods: {
    //获取列表数据
    getData() {
      this.$layer.loading();
      this.$http.get('memorial/' + this.setid).then((res) => {
        if (res.data.code == 200) {
          this.$layer.closeAll('loading');
          this.infolist = res.data.data;
          this.infolist.life_tracks.forEach(item =>{
            this.$set(item,"showMore",false);
          })
        } else {
          this.$layer.msg(res.data.message);
        }
      })
    },
    showMore(item) {
      item.showMore = !item.showMore
    },
    //切换
    tab(id) {
      this.isave = id;
    },
  },
};
</script>
<style scoped>
img {
  object-fit: fill;
}

.content {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  height: 787px;

}

.Memor-box {
  background: url(../../../public/images/jntbj3.jpg);
  /* background-repeat: no-repeat; */
  background-size: 100% 100%;
  position: relative;
  /* background: #332f28; */
  height: 787px;
}

.Memor-left {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 22%;
  object-fit: contain;
}

.Memor-left img {
  width: 100%;
  object-fit: contain;
}

.Memor-zhong {
  position: absolute;
  top: 0;
  width: 640px;
  height: 100%;
  left: 45px;
}

.Memor-zhong img {
  width: 640px;
  position: relative;
  bottom: 414px;
  /* right: 35px; */
  /* height: 904px; */

}

.Memor-smb {
  width: 100%;
  height: 100%;
}



.Memor-name {
  width: 276px;
  height: 122px;
  background: url(../../../public/images/bjmc.png) no-repeat;
  background-size: 276px 122px;
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translate(-50%, 0);
  font-weight: bold;
  font-size: 24px;
  color: #F3E3D6;
  text-align: center;
  line-height: 106px;
}

.Memor-cs {
  position: absolute;
  top: 134px;
  left: 50%;
  font-size: 16px;
  color: #F3E3D6;
  transform: translate(-50%, 0);
}

.Memor-goin {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 200px;
  height: 36px;
  background: linear-gradient(139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
  border-radius: 18px;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  line-height: 36px;
}

.Memor-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 42%;
}

.Memor-right img {
  width: 100%;
  object-fit: contain;
}

.Memor-cent {
  width: 100%;
  height: 100%;
  position: relative;
}

.Memor-info {
  position: absolute;
  left: -11px;
  width: 468px;
  height: 787px;
  background: #F3E3D6;

}

.Memor-tab {
  width: 400px;
  margin: 25px auto 0;
}

.Memor-tab span {
  display: inline-block;
  width: 96px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 18px;
  font-size: 18px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  margin: 0 18px;
  cursor: pointer;
}

.Memor-tab span.on {
  background: #D71E1C;
  color: #fff;

}

.Memor-text {
  padding: 30px;
  font-size: 16px;
  color: #333333;
  line-height: 32px;
  height: 76%;
  overflow: auto;
}

.Memor-text::-webkit-scrollbar {
  width: 2px;
  height: 4px;
  margin-top: 10px;
}

::v-deep .Bottom-box {
  margin-top: 0 !important;
}

.tracks_title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.tracks_img {
  max-width: 200px !important;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
}

.tracks_detail {
  font-size: 14px;
  line-height: 20px;
  text-indent: 2em;
}

.tracks_btn {
  font-size: 14px;
  margin-bottom: 20px;
  color: rgb(77, 122, 205);
  text-align: right;
  cursor: pointer;
}

.ell {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Memor-text h4 {
  margin: 0;
}
</style>